<div class="ctdLimit">
  <p [innerHTML]="'installation_ctdLimit' | translate"></p>
</div>
